module.exports = __webpack_public_path__ + "img/music-icon-red.b5c54cc1.png";